import type { Template } from "@/types";

export const PO_05_H4_V1: Template[] = [
    {
        id: "po-05-h4v1-01",
        name: "PO 01 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 237, width: 502, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 692, y: 195, width: 205, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 692, y: 328, width: 205, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 692, y: 462, width: 205, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 904, y: 195, width: 287, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-02",
        name: "PO 02 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 190, y: 80, width: 247, height: 150, rotation: 0, imageRotation: 0 },
            { id: "2", x: 190, y: 238, width: 247, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 190, y: 395, width: 247, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 190, y: 552, width: 247, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 722, y: 80, width: 434, height: 622, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-03",
        name: "PO 03 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 34, y: 198, width: 307, height: 191, rotation: 0, imageRotation: 0 },
            { id: "2", x: 34, y: 396, width: 307, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 0, width: 556, height: 783, rotation: 0, imageRotation: 0 },
            { id: "4", x: 911, y: 198, width: 307, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 911, y: 396, width: 307, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-04",
        name: "PO 04 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 27, y: 150, width: 576, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 27, y: 516, width: 188, height: 118, rotation: 0, imageRotation: 0 },
            { id: "3", x: 222, y: 516, width: 187, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 416, y: 516, width: 187, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 764, y: 150, width: 352, height: 485, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-05",
        name: "PO 05 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 180, y: 125, width: 282, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 32, y: 305, width: 282, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 320, y: 305, width: 282, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 180, y: 485, width: 282, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 748, y: 125, width: 382, height: 534, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-06",
        name: "PO 06 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 325, width: 210, height: 132, rotation: 0, imageRotation: 0 },
            { id: "2", x: 218, y: 325, width: 210, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 125, width: 381, height: 534, rotation: 0, imageRotation: 0 },
            { id: "4", x: 824, y: 325, width: 210, height: 132, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1042, y: 325, width: 210, height: 132, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-07",
        name: "PO 07 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 558, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 689, y: 178, width: 499, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 689, y: 495, width: 162, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 858, y: 495, width: 161, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1027, y: 495, width: 161, height: 110, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-08",
        name: "PO 08 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 77, y: 61, width: 473, height: 662, rotation: 0, imageRotation: 0 },
            { id: "2", x: 677, y: 228, width: 259, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 677, y: 395, width: 259, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 228, width: 259, height: 160, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 395, width: 259, height: 160, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-09",
        name: "PO 09 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 204, width: 586, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 592, y: 204, width: 384, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 592, y: 462, width: 189, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 787, y: 462, width: 189, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 982, y: 204, width: 269, height: 375, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-10",
        name: "PO 10 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 184, height: 120, rotation: 0, imageRotation: 0 },
            { id: "2", x: 190, y: 201, width: 185, height: 120, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 327, width: 375, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 382, y: 201, width: 595, height: 381, rotation: 0, imageRotation: 0 },
            { id: "5", x: 984, y: 201, width: 269, height: 381, rotation: 0, imageRotation: 0 }
        ],
    }
];